var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flag)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g(_vm._b({staticClass:"country-flag-indicator"},'div',attrs,false),on),[_vm._v(" "+_vm._s(_vm.flag)+" ")])]}}],null,false,967117207)},[_c('span',[_vm._v("Lieferung nach "+_vm._s(_vm.name))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }